import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _Set from "@babel/runtime-corejs3/core-js/set";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import { useInstance } from 'intact-vue';
export function useSelected(getNodes) {
  var instance = useInstance();
  var selectedKeys = new _Set();
  instance.on('$receive:selectedKeys', function (v) {
    selectedKeys = new _Set(v);
  });
  function toggle(_x) {
    return _toggle.apply(this, arguments);
  }
  function _toggle() {
    _toggle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(node) {
      var key, _instance$get, multiple;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!node.data.disabled) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            key = node.key;
            _instance$get = instance.get(), multiple = _instance$get.multiple;
            if (selectedKeys.has(key)) {
              selectedKeys.delete(key);
            } else {
              if (!multiple) {
                selectedKeys.clear();
              }
              selectedKeys.add(key);
            }
            instance.set('selectedKeys', _Array$from(selectedKeys));
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _toggle.apply(this, arguments);
  }
  function getSelectedData() {
    var data = [];
    var size = selectedKeys.size;
    if (!size) return data;
    var count = 0;
    var loop = function loop(nodes) {
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (selectedKeys.has(node.key)) {
          data.push(node.data);
          if (++count === size) return;
        }
        if (node.children) {
          loop(node.children);
        }
      }
    };
    loop(getNodes());
    return data;
  }
  return {
    get: function get() {
      return selectedKeys;
    },
    toggle: toggle,
    getSelectedData: getSelectedData
  };
}